import styled from 'styled-components'
import { MAX_SIDEBAR_WIDTH } from '../PageCanvasSidebar/useResizeSidebar'
/** We are using multiple overlays on top of the canvas */
const zIndex = {
  canvasStatus: 1,
  betaTooltip: 1,
}

export const StyledPageCanvas = styled.div`
  position: relative;
  width: calc(100% - ${MAX_SIDEBAR_WIDTH}px);
  height: 100%;
  /*
   * Some versions of safari ignore height: 100% in some flexbox context.
   * So we use flex-grow:1 to force the element to take all the available space.
   */
  flex-grow: 1;
  /*
   * Continue propagation of flex flow to the child canvas
   * so that the height of the canvas is automatically 100% of the parent.
   https://github.com/sketch-hq/Cloud/issues/10223
   */
  display: flex;
`

export const StyledWebRendererStatusContainer = styled.div`
  position: absolute;
  z-index: ${zIndex.canvasStatus};
  background-color: ${({ theme }) => theme.colors.background.secondary.B};
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-self: center;
  justify-content: center;
`

export const PageCanvasWrapper = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`
